import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { DocumentsApiService } from 'features/document-report/api/documents-api.service';
import { queryClient } from 'providers';

import { DocumentQueryKeys } from './query-keys';
const { UploadDocuments } = DocumentsApiService();

export const useUploadDocuments = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: any) => {
      return UploadDocuments(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data: any) => {
        queryClient.invalidateQueries({
          queryKey: DocumentQueryKeys.all,
        });
        if (data?.rs == 1) {
          message.success('Document Upload Succssfully');
        }
      },
    },
  );
};
